var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('update-features'),_c('nav-vertical'),_c('tasks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }